import React from 'react';
import TrainAI from '../../components/TrainAI';
import AppLayout from '../../layouts/AppLayout';
import './styles.css';

function TrainAIPage() {
  return (
    <AppLayout title="Treinar IA" subtitle="Contexto da marca" fullWidth>
      <TrainAI />
    </AppLayout>
  );
}

export default TrainAIPage;
